import { styled } from '@mui/material';

const StyledTable = styled('table')(({ theme }) => ({
  borderCollapse: 'separate',
  borderSpacing: 0,
  width: 'auto',
}));

const StyledThead = styled('thead')({});

const StyledTh = styled('th')(({ theme, sx }) => ({
  marginTop: '5px',
  color: "#212121",
  fontFamily: "Roboto",
  fontSize: "0.75rem",
  fontWeight: 400,
  letterSpacing: "0em",
  backgroundColor: "#F6F7F9",
  height: "2.75rem",
  textTransform: 'none',
  borderRadius: '0px',
  padding: '12px 10px',
  textAlign: 'center',
  verticalAlign: 'middle',
  cursor: 'default',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  whiteSpace: 'nowrap',
  ...sx,
}));

const TextDisplayComponent = ({
  items,
  tableSx = {},
  headerSx = {},
  cellSx = {},
  className = ''
}) => {
  const getCellStyles = (index, totalItems) => {
    const baseStyles = {
      ...cellSx,
    };

    if (totalItems === 1) {
      // Single item - all corners rounded
      return {
        ...baseStyles,
        borderRadius: '8px 8px 8px 8px',
      };
    }

    if (index === 0) {
      // First item - left corners rounded, no right border
      return {
        ...baseStyles,
        borderRadius: '8px 0px 0px 8px',
        borderRight: 'none',
      };
    }

    if (index === totalItems - 1) {
      // Last item - right corners rounded
      return {
        ...baseStyles,
        borderRadius: '0px 8px 8px 0px',
      };
    }

    // Middle items - no border radius, no right border
    return {
      ...baseStyles,
      borderRight: 'none',
    };
  };

  // Return null if no items
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <StyledTable sx={tableSx} className={className}>
      <StyledThead sx={headerSx}>
        <tr>
          {items.map((value, index) => (
            <StyledTh
              key={index}
              sx={getCellStyles(index, items.length)}
            >
              {value}
            </StyledTh>
          ))}
        </tr>
      </StyledThead>
    </StyledTable>
  );
};

export default TextDisplayComponent;